export default __webpack_public_path__ + "static/media/totalusers.8c9f035c.svg";